import styles from "../../../styles/MobileNumberRegister.module.css";

// images
import RegisterMobileNumberImg from "../../../assets/images/register-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";
import ContactUsModalImage from "../../../assets/images/contact-us-modal-image.png";

// legion
import {
  Checkbox,
  Flex,
  Button,
  Text,
  Anchor,
  Textfield,
  Modal,
  Image,
} from "@legion-ui/core";

import { Link } from "react-router-dom";

// hooks
import { useEmailAddressRegister } from "../../../hooks/useEmailAddressRegister";

export const EmailAddressRegister = () => {
  const { showModal, state, handleForms, handleRegister, handleBackToSignIn } =
    useEmailAddressRegister();

  return (
    <Flex width="100%" height="100%">
      <Modal show={showModal} width="528px">
        <Image
          width="146px"
          src={ContactUsModalImage}
          alt="modal letter image"
          margin="auto"
        />

        <Text
          as="p"
          size="24px"
          color="tertiary900"
          margin="10px 0 8px 0"
          weight="700"
          style={{ textAlign: "center" }}
        >
          Account Registration Success
        </Text>

        <Text
          as="p"
          color="tertiary500"
          margin="0 0 24px 0"
          style={{ textAlign: "center" }}
        >
          Thank you for registering. Please check your email for confirmation
          and sign in with your account.
        </Text>

        <Button block center variant="solid" onClick={handleBackToSignIn}>
          Back to Sign In
        </Button>
      </Modal>

      <Flex
        alignY="center"
        alignX="center"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.register__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Sign Up
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Create and register your account to discover all your needed
          </Text>

          <Textfield
            label="Full Name"
            placeholder="Type your full name"
            type="text"
            padding="0 0 24px 0"
            status={state.fullNameStatus}
            message={state.fullNameErrorMessage}
            onChange={handleForms("fullName")}
          />

          <Textfield
            label="User Name"
            placeholder="Type your user name"
            type="text"
            padding="0 0 24px 0"
            status={state.userNameStatus}
            message={state.userNameErrorMessage}
            onChange={handleForms("userName")}
          />

          <Textfield
            label="Email"
            placeholder="name@mail.com"
            type="text"
            padding="0 0 24px 0"
            status={state.emailStatus}
            message={state.emailErrorMessage}
            onChange={handleForms("email")}
          />

          <Textfield
            before="+62"
            label="Mobile Number"
            placeholder="85123456XXXXX"
            type="number"
            padding="0 0 24px 0"
            status={state.phoneNumberStatus}
            message={state.phoneNumberErrorMessage}
            onChange={handleForms("phoneNumber")}
          />

          <Checkbox required label={<>I agree to <Link to='/tnc'>Terms & Condition</Link> and <Link to='/privacy-policy'>Privacy Policy</Link></>} />

          <Button margin="24px 0 32px 0" center onClick={handleRegister}>
            Register
          </Button>

          <div style={{ textAlign: "center" }}>
            <Text margin="0 0 40px 0" as="p" color="tertiary500">
              Already have an account?{" "}
              <Anchor
                href="/login/email-address"
                weight="700"
                color="primary500"
              >
                Sign In
              </Anchor>
            </Text>
            <Text as="p" color="tertiary500">
              &#9432; Forgot your mobile number?
            </Text>
            <Anchor
              href="/contact-us/email-address"
              weight="700"
              color="primary500"
            >
              Contact Us
            </Anchor>
          </div>
        </Flex>
      </Flex>

      <Flex alignX="end" className={styles.register__image} width={["", "50%"]}>
        <Image
          width="auto"
          height="100%"
          src={RegisterMobileNumberImg}
          fit="cover"
          alt="register mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
